import { setSearchTerm } from '../State/searchTerm';

export default (event) => async (dispatch) => {

  dispatch(setSearchTerm(event.target.value));
  
}